import { KlLink } from 'components/_shared'
import React, { ReactNode } from 'react'
import { cn } from 'utils'

import styles from '../Header.module.scss'

interface VerticalHeaderItemProps {
  to: string
  text: string
  onClick?: () => void
  icon?: string
  children?: ReactNode
}

const VerticalHeaderItem = ({ to, text, onClick, icon, children }: VerticalHeaderItemProps) => {
  return (
    <>
      <KlLink className={cn(styles.profileDropdown__section, 'd-flex flex-row align-items-center')} to={to} onClick={onClick}>
        {icon && <span className={cn(styles.profileDropdown__icon,  icon)} />}
        {children}
        <span className={styles.profileDropdown__text}>{text}</span>
      </KlLink>
    </>
  )
}

export default VerticalHeaderItem
